import { useCallback } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { useDispatch } from 'react-redux'
import { openModal } from '@store/modalsSlise'
import TYPES from '@modals/TYPES'
import s from './TiptapImage.module.css'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { useImage } from './context/ImageContext'

const TiptapImage = ({ node, editor, getPos }) => {
  const dispatch = useDispatch()
  const { tooltipText, clickByImage } = useImage()
  const isImageActionAvailable = editor.isEditable || !!clickByImage

  const handleClick = useCallback(() => {
    dispatch(openModal({
      type: TYPES.TIPTAP_RESIZE_IMAGE, 
      data: { getPos, editor, node }
    }))
  }, [getPos, editor, node])

  const image = (
    <img
      src={node.attrs.src}
      alt={node.attrs.alt}
      title={node.attrs.title}
      style={{
        width: node.attrs.width,
        maxWidth: '100%',
      }}
      className={s.resizableImage}
      onClick={
        clickByImage
          ? () => clickByImage?.(node.attrs.src)
          : editor.isEditable
          ? handleClick
          : undefined
      }
    />
  )

  return (
    <NodeViewWrapper className={s.resizableImageContainer}>
      {isImageActionAvailable ? (
        <TooltipWrapper placement="right" title={tooltipText ?? ''}>
          {image}
        </TooltipWrapper>
      ) : (
        image
      )}
    </NodeViewWrapper>
  )
}

export default TiptapImage
